"use client";

import { usePathname } from "next/navigation";
import { useState, useCallback } from "react";
import { Header } from "@/components/layout/Header";
import { NavDrawer } from "@/components/layout/NavDrawer";
import { MobileNav } from "@/components/layout/MobileNav";

export default function DashboardLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const closeDrawer = useCallback(() => setDrawerOpen(false), []);

  const isPOS = pathname === "/dashboard/pos";
  const isKitchen = pathname === "/dashboard/kitchen";
  const isFullScreen = isPOS || isKitchen;

  // POS and Kitchen get full-screen — no header, no nav
  if (isFullScreen) {
    return (
      <div className="h-screen flex flex-col bg-black">
        {children}
      </div>
    );
  }

  // All other pages get header + drawer navigation
  return (
    <div className="flex h-screen flex-col bg-black">
      <Header onMenuClick={() => setDrawerOpen(true)} />
      <NavDrawer isOpen={drawerOpen} onClose={closeDrawer} />
      <main className="flex-1 overflow-y-auto p-4 pb-20 lg:p-6 lg:pb-6">
        {children}
      </main>
      <MobileNav />
    </div>
  );
}
